
import { Helmet } from "react-helmet-async";

interface OrganizationSchemaProps {
  name?: string;
  url?: string;
  logo?: string;
  description?: string;
}

interface ArticleSchemaProps {
  title: string;
  image: string;
  datePublished: string;
  dateModified?: string;
  authorName: string;
  description: string;
  url: string;
}

export const OrganizationSchema = ({
  name = "Seed Potato Organisation",
  url = "https://seedpotatoorganisation.com",
  logo = "/lovable-uploads/2209c5e8-f8a9-4079-a2f4-f34eb5169b81.png",
  description = "Supporting Scottish Seed Potato Industry. Run by growers for growers."
}: OrganizationSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name,
    url,
    logo: `${url}${logo}`,
    description,
    sameAs: [
      // Add social media URLs when available
    ]
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export const ArticleSchema = ({
  title,
  image,
  datePublished,
  dateModified,
  authorName,
  description,
  url
}: ArticleSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: title,
    image: image.startsWith("http") ? image : `https://seedpotatoorganisation.com${image}`,
    datePublished,
    dateModified: dateModified || datePublished,
    author: {
      "@type": "Person",
      name: authorName
    },
    publisher: {
      "@type": "Organization",
      name: "Seed Potato Organisation",
      logo: {
        "@type": "ImageObject",
        url: "https://seedpotatoorganisation.com/lovable-uploads/2209c5e8-f8a9-4079-a2f4-f34eb5169b81.png"
      }
    },
    description,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
